var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"ad_mask"},[_c('span',{on:{"click":function($event){_vm.$emit('done')}}},[_vm._v("跳过"),_c('a',{staticClass:"cs"},[_vm._v(_vm._s(_vm.times))]),_vm._v("秒")])])])}
var staticRenderFns = []

export { render, staticRenderFns }